<template>
  <div>
    <card class="card" title="Roles">
      <div class="card__right-button">
        <div class="position-relative">
          <button class="btn btn-just-icon btn-outline-warning mr-3 tooltipBtn" @click="openAddRoleModal()">
            <i class="fas fa-plus" />
          </button>
          <div class="tooltipCustom tooltipCustom--bottom">Assign new Role</div>
        </div>
      </div>
      <div v-if="roles">
        <div v-if="roles.length > 0">
          <div v-for="(role, index) in roles" v-bind:key="index">
            <div class="row">
              <div class="col">
                <label for="role_name" class="control-label">Name</label>
                <p id="role_name" class="text-title">{{ role.data.name }}</p>
              </div>
              <div class="col">
                <label for="description" class="control-label">Description</label>
                <p id="description" class="description">{{ role.data.description }}</p>
              </div>
              <div class="col button-group">
                <div v-if="checkScopes('updateSystemRole')" class="mr-3">
                  <router-link :to="'/super_user/company/' + obj.company_id + '/role/' + role.data.role_id">
                    <p-button type="success" outline icon>
                      <i class="fa fa-edit" />
                    </p-button>
                  </router-link>
                </div>

                <p-button round icon type="danger" outline @click.native.prevent="setRoleForDelete(role, index)">
                  <i class="fa fa-trash" />
                </p-button>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <p>{{ $t('No_roles_are_assigned_for_this_user_yet') }}</p>
        </div>
      </div>
    </card>

    <!-- Modals -->

    <ModalTemplate
      component-name="DeleteModal"
      button-component-name="DeleteButton"
      action="removeRole"
      :data="{
        deletion_object_name: deletion_role_name,
        deletion_object_text: $t('this_role'),
        delete_button_title: $t('remove_role'),
        header: $t('remove_role'),
        placeholder: $t('remove'),
        confirmation_word: $t('remove'),
        delete_button_name: $t('remove'),
      }"
      :clicked="open_delete_modal"
      @update:field="open_delete_modal = false"
      @submit="removeRole()"
    >
    </ModalTemplate>

    <ModalTemplate
      component-name="AddRoleModal"
      action="addRoleToUser"
      button-component-name="CreateNewButton"
      :data="{
        roles: roles_for_select,
        obj: obj,
        obj_name: obj_name,
        header: $t('Assign_new_role'),
      }"
      :button_data="{
        title: $t('Assign_new_role'),
        name: $t('Assign_new_role'),
      }"
      :clicked="open_add_role_modal"
      @update:field="open_add_role_modal = false"
      @submit="addRole($event)"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import AddRoleToUserModal from '../../../components/modals/AddRoleModal';
import DeleteButton from '../../../components/buttons/DeleteButton';
import DeleteModal from '../../../components/modals/DeleteModal';
import ModalTemplate from '../../../components/modals/ModalTemplate';
import scopesChecker from '../../../router/scopes/scopesChecker';
export default {
  name: 'RolesIndex',
  components: { ModalTemplate, DeleteModal, DeleteButton, AddRoleToUserModal },
  props: ['roles', 'obj', 'obj_name', 'roles_for_select'],
  data: function () {
    return {
      roles_result: {},
      open_delete_modal: false,
      open_add_role_modal: false,
      deletion_role_name: '',
      deletion_role_index: null,
      deletion_role: null,
    };
  },
  methods: {
    openAddRoleModal() {
      this.open_add_role_modal = true;
    },
    checkScopes: function (action) {
      return scopesChecker(null, this.$route.name, action);
    },
    setRoleForDelete: function (role, index) {
      this.open_delete_modal = true;
      this.deletion_role = role;
      this.deletion_role_name = role.data.name;
      this.deletion_role_index = index;
    },
    removeRole: function () {
      this.$emit('removeRole', this.deletion_role);
    },
    addRole: function (event) {
      this.$emit('addRole', event);
    },
  },
};
</script>

<style scoped></style>
